export default "__VITE_ASSET__C_24rupN__"